/* JMB personalization: product-page form + add-on line.
   - The personalization fields live inside the product form, so the theme's own
     add-to-cart sends them as line item properties on the item.
   - Paid options also add one line of the hidden "Personalization" product, linked
     to the item by a shared hidden _pers_id property. cart-sync (in theme.liquid)
     keeps that line's quantity matched to the item and removes it if the item is removed. */
(function () {
  if (window.__jmbPersInit) return;
  window.__jmbPersInit = true;

  var DIE_CHARS = /^[A-Z0-9:.,@&#\/–\-! ]+$/;
  var LABELS = {
    blind: 'Stamped initials, blind',
    foil: 'Stamped initials, foil',
    laser: 'Laser-engraved text',
    artwork: 'Custom laser artwork (quote by email)'
  };

  function setup(root) {
    if (root.__jmbReady) return;
    root.__jmbReady = true;
    var toggle = root.querySelector('[data-jmb-pers-toggle]');
    var body = root.querySelector('[data-jmb-pers-body]');
    var radios = root.querySelectorAll('input[name="jmb_pers_method"]');
    var foilWrap = root.querySelector('[data-jmb-pers-foil]');
    var foilSel = root.querySelector('[data-jmb-pers-foil-select]');
    var textWrap = root.querySelector('[data-jmb-pers-text-wrap]');
    var text = root.querySelector('[data-jmb-pers-text]');
    var textLabel = root.querySelector('[data-jmb-pers-text-label]');
    var hint = root.querySelector('[data-jmb-pers-text-hint]');
    var err = root.querySelector('[data-jmb-pers-error]');

    function method() {
      var r = root.querySelector('input[name="jmb_pers_method"]:checked');
      return r ? r.value : '';
    }

    function refresh() {
      var on = toggle.checked;
      body.hidden = !on;
      root.querySelectorAll('input, select, textarea').forEach(function (el) {
        if (el !== toggle) el.disabled = !on;
      });
      var m = method();
      var stamp = m === 'blind' || m === 'foil';
      foilWrap.hidden = !(on && m === 'foil');
      foilSel.disabled = !(on && m === 'foil');
      var needsText = on && (stamp || m === 'laser');
      textWrap.hidden = !needsText;
      text.disabled = !needsText;
      if (stamp) {
        textLabel.textContent = 'Initials';
        text.maxLength = 3;
        hint.textContent = 'Up to 3 characters: capital letters, numbers, or : . , @ & # / – !';
        text.value = text.value.toUpperCase().slice(0, 3);
      } else if (m === 'laser') {
        textLabel.textContent = 'Name or text';
        text.maxLength = 20;
        hint.textContent = 'Up to 20 characters. Longer text? Describe it in the notes.';
      }
      if (err) err.hidden = true;
    }

    toggle.addEventListener('change', refresh);
    radios.forEach(function (r) { r.addEventListener('change', refresh); });
    text.addEventListener('input', function () {
      var m = method();
      if (m === 'blind' || m === 'foil') text.value = text.value.toUpperCase();
    });
    refresh();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-jmb-pers]').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Quick-view / re-rendered product sections
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  function token() {
    return 'P' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function fail(root, msg, e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    var err = root.querySelector('[data-jmb-pers-error]');
    err.textContent = msg;
    err.hidden = false;
    err.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  // Capture phase on document: runs before the theme's own submit handling.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-product-form]')) return;
    var root = form.querySelector('[data-jmb-pers]');
    if (!root) return;
    if (form.dataset.jmbPersPass === '1') { delete form.dataset.jmbPersPass; return; }
    var toggle = root.querySelector('[data-jmb-pers-toggle]');
    if (!toggle || !toggle.checked) return;

    var r = root.querySelector('input[name="jmb_pers_method"]:checked');
    if (!r) return fail(root, 'Please choose a personalization method.', e);
    var m = r.value;
    var text = root.querySelector('[data-jmb-pers-text]');
    var val = (text.value || '').trim();
    if (m === 'blind' || m === 'foil') {
      val = val.toUpperCase();
      text.value = val;
      if (!val) return fail(root, 'Please enter the initials to stamp.', e);
      if (val.length > 3 || !DIE_CHARS.test(val)) return fail(root, 'Stamped initials can be up to 3 capital letters, numbers or : . , @ & # / – !', e);
    }
    if (m === 'laser' && !val) return fail(root, 'Please enter the name or text to engrave.', e);
    if (m === 'artwork' && !(root.querySelector('textarea').value || '').trim()) {
      return fail(root, 'Please describe the artwork in the notes; we will email you to follow up.', e);
    }
    if (!root.querySelector('[data-jmb-pers-ack]').checked) {
      return fail(root, 'Please confirm that personalized items are final sale.', e);
    }

    var notes = root.querySelector('textarea');
    if (notes && !notes.value.trim()) notes.disabled = true; // don't save an empty notes line

    var summary = LABELS[m];
    if (m === 'foil') summary += ', ' + root.querySelector('[data-jmb-pers-foil-select]').value;
    if (m === 'blind' && !root.dataset.blindId) summary += ' (complimentary)';
    var id = token();
    root.querySelector('[data-jmb-pers-summary]').value = summary;
    root.querySelector('[data-jmb-pers-id]').value = id;

    var addonId = { blind: root.dataset.blindId, foil: root.dataset.foilId, laser: root.dataset.laserId }[m];
    if (!addonId) return; // complimentary blind or quoted artwork: properties only

    e.preventDefault();
    e.stopImmediatePropagation();
    var qtyInput = form.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var props = { 'For': root.dataset.productTitle, 'Details': summary + (val ? ': ' + val : ''), '_pers_id': id };
    fetch((window.theme && window.theme.routes ? window.theme.routes.root_url : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(addonId), quantity: qty, properties: props }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('add-on failed');
      form.dataset.jmbPersPass = '1';
      if (form.requestSubmit) {
        var btn = form.querySelector('[type="submit"][name="add"]');
        btn ? form.requestSubmit(btn) : form.requestSubmit();
      } else {
        form.submit();
      }
    }).catch(function () {
      var err = root.querySelector('[data-jmb-pers-error]');
      err.textContent = 'Sorry, we could not add the personalization. Please try again or contact us.';
      err.hidden = false;
    });
  }, true);
})();
